import { useEffect } from "react";
import {songDetailsPage} from "../../../../services/songs/songDetailsPage";
import {isDefined} from "../../../../util/is-type";
import {useSongDetailsRouterParams} from "./hooks/useSongDetailsRouterParams";

export interface ISongDetailsPageLogic {
  isLessonIdSelected: boolean;
}

export const useSongDetailsPageLogic = (): ISongDetailsPageLogic => {
  const {songId, lessonId} = useSongDetailsRouterParams();

  useEffect(() => {
    void songDetailsPage.selectSongIdAndAttemptLoad(songId);
    return () => { songDetailsPage.reset(); };
  }, [songId]);

  return {
    isLessonIdSelected: isDefined(lessonId),
  };
}
